var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
$CLJS.MA=require("ttag");module.exports=$CLJS.MA;